import { Component, OnInit, signal } from '@angular/core';
import { CardDetailsComponent } from "./card-details/card-details.component";
import { TargetChartComponent } from "../target-chart/target-chart.component";
import { BackToTopComponent } from '../../../../shared-components/back-to-top/back-to-top.component';
import { TrainingBudgetComponent } from "./training-budget/training-budget.component";
import { TrainingWisePaymentChartComponent } from './training-wise-payment-chart/training-wise-payment-chart.component';
import { TrainingPlanchartComponent } from "./training-planchart/training-planchart.component";
import { TrainingPlanHierarchySummaryComponent } from "./training-plan-hierarchy-summary/training-plan-hierarchy-summary.component";
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { TmsCommonMasterDataService } from '../../../../data-services/tms-commonmaster-data.service';
import { TmsMastersDataService } from '../../../../data-services/tms-masters-data.service';
import { TmsTrainingDataService } from '../../../../data-services/tms-training-data.service';
import { OrganizationUnitDefinition } from '../../../../data-services/api-models/config-service-models';
import { TrainingCategory, Training, FinancialPeriod } from '../../../../data-services/api-models/tms-service-models';

@Component({
    selector: 'app-crm',
     standalone: true,
    imports: [CardDetailsComponent, BackToTopComponent, TargetChartComponent, TrainingBudgetComponent, TrainingWisePaymentChartComponent, TrainingPlanchartComponent, TrainingPlanHierarchySummaryComponent,
    MatSelectModule, MatIconModule, MatRadioModule, MatSlideToggleModule, MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatNativeDateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
    ],
    providers: [TmsCommonMasterDataService, TmsMastersDataService, TmsTrainingDataService],
    templateUrl: './crm.component.html',
    styleUrl: './crm.component.scss'
})
export class CrmComponent implements OnInit {
  districtList: OrganizationUnitDefinition[] = [];
  trainingThemes: TrainingCategory[] = [];
  trainingList: Training[] = [];
  filteredTrainingList: Training[] = [];
  sessionList: FinancialPeriod[] = [];

  selectedDistrictId = signal<string | undefined>(undefined);
  selectedThemeId = signal<string | undefined>(undefined);
  selectedTrainingId = signal<string | undefined>(undefined);
  selectedSessionId = signal<string | undefined>(undefined);
  paymentData = signal<any[] | null>(null);
  trainingPlanStatusData = signal<any[] | null>(null);
  paymentError = signal<string | null>(null);

  filterForm!: FormGroup;

  constructor(
    private commonapiService: TmsCommonMasterDataService,
    private tmsMastersService: TmsMastersDataService,
    private trainingDataService: TmsTrainingDataService,
    private formBuilder: FormBuilder
  ) {
    this.filterForm = this.formBuilder.group({
      district: [''],
      trainingTheme: [''],
      training: [''],
      session: ['']
    });
  }

  ngOnInit(): void {
    this.loadFilters();
  }

  private loadFilters(): void {
    this.loadDistrictList();
    this.loadTrainingThemes();
    this.loadTrainings();
    this.loadFinancialPeriods();
  }

  private loadDistrictList(): void {
    this.commonapiService.getDistrict().subscribe({
      next: (districts) => {
        this.districtList = districts;
      },
      error: (err) => {
        console.error('Error loading district list:', err);
      }
    });
  }

  private loadTrainingThemes(): void {
    this.tmsMastersService.getTrainingTheme().subscribe({
      next: (themes) => {
        this.trainingThemes = themes;
      },
      error: (err) => {
        console.error('Error loading training themes:', err);
      }
    });
  }

  private loadTrainings(): void {
    this.tmsMastersService.getTraining().subscribe({
      next: (trainings) => {
        this.trainingList = trainings;
        this.filteredTrainingList = trainings;
      },
      error: (err) => {
        console.error('Error loading training list:', err);
      }
    });
  }

  private loadFinancialPeriods(): void {
    this.tmsMastersService.getFinancial().subscribe({
      next: (periods) => {
        this.sessionList = (periods || []).filter((period) => Number(period.frequencyId) === 10);
      },
      error: (err) => {
        console.error('Error loading financial periods:', err);
      }
    });
  }

  onThemeChange(themeId: string): void {
    this.selectedThemeId.set(themeId);
    this.filteredTrainingList = themeId
      ? this.trainingList.filter(t => t.categoryId === themeId)
      : this.trainingList;
    this.selectedTrainingId.set(undefined);
  }

  onDistrictChange(): void {
    // Trigger dashboard/chart refresh on district change
  }

  onTrainingChange(): void {
    // Trigger dashboard/chart refresh on training change
  }

  onSessionChange(): void {
    // Trigger dashboard/chart refresh on session change
  }

  onSearch(): void {
    const districtId = this.selectedDistrictId();
  //  const districtId  = 'c76d47ab-f2e2-f011-85db-0a109c2be0e1';
    const financialId = this.selectedSessionId();

    if (!districtId || !financialId) {
      this.paymentData.set(null);
      this.paymentError.set('Please select district and session to load payment data.');
      return;
    }

    this.paymentError.set(null);

    this.trainingDataService.getPaymentDisbursementReportByFilterIds(
      districtId,
      financialId,
      this.getApiFilterValue(this.selectedTrainingId())
    ).subscribe({
      next: (data) => {
        this.paymentData.set(Array.isArray(data) ? data : []);
      },
      error: (err) => {
         console.error('Error loading payment status report:', err);
        this.paymentData.set(null);
        this.paymentError.set('Unable to load payment data right now.');
      }
    });

    this.trainingDataService.getPaymentDisbursementPaymentStatusReport(
      districtId,
      financialId,
      this.getApiFilterValue(this.selectedTrainingId())
    ).subscribe({
      next: (data) => {
        this.trainingPlanStatusData.set(Array.isArray(data) ? data : []);
      },
      error: (err) => {
        console.error('Error loading training plan status report:', err);
        this.trainingPlanStatusData.set(null);
      }
    });
  }

  private getApiFilterValue(value: string | undefined): string {
    return value?.trim() ? value : 'null';
  }
}
